import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import TimelineSection from './components/TimelineSection';
import timelineData from './data/timelineData.json';

// Store roots to prevent duplicate createRoot calls
const roots = new Map();

// Create a widget that can be embedded anywhere
window.TimelineWidget = {
    render: function (containerId) {
        const container = document.getElementById(containerId);
        if (container) {
            // Check if we already have a root for this container
            let root = roots.get(containerId);

            if (!root) {
                // Create a new root only if one doesn't exist
                root = ReactDOM.createRoot(container);
                roots.set(containerId, root);
            }

            // Render the component
            root.render(<TimelineSection timelineData={timelineData} />);
        }
    },

    // Optional: method to unmount a widget
    unmount: function (containerId) {
        const root = roots.get(containerId);
        if (root) {
            root.unmount();
            roots.delete(containerId);
        }
    }
};